class VariantIngredients {
  constructor(parent) {
    this.parent = parent;
    this.sectionId = parent.getAttribute('data-section-id');
    this.productUrl = this.getProductUrl();
    this.container = parent.closest('[id^="shopify-section-"]');
    this.boundOnVariantChange = this.onVariantChange.bind(this);
    this.boundOnVariantIdChange = this.onVariantIdChange.bind(this);
  }

  getProductUrl() {
    if (this.parent.getAttribute('data-product-url')) {
      return this.parent.getAttribute('data-product-url');
    }
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects && variantSelects.dataset.url) {
      return variantSelects.dataset.url;
    }
    if (window.location.pathname.indexOf('/products/') === 0) {
      return window.location.pathname;
    }
    return null;
  }

  updateIngredients(variantId) {
    if (!this.sectionId || !this.productUrl || !this.container) return;

    const url =
      this.productUrl +
      (this.productUrl.indexOf('?') !== -1 ? '&' : '?') +
      'variant=' +
      encodeURIComponent(variantId) +
      '&section_id=' +
      encodeURIComponent(this.sectionId);

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(
        function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const sourceSection = doc.getElementById(
            'shopify-section-' + this.sectionId
          );
          if (sourceSection && sourceSection.innerHTML !== undefined) {
            this.container.innerHTML = sourceSection.innerHTML;
          }
        }.bind(this)
      )
      .catch(function () {});
  }

  onVariantChange(e) {
    if (e.detail && e.detail.variant && e.detail.variant.id) {
      this.updateIngredients(String(e.detail.variant.id));
    }
  }

  onVariantIdChange(e) {
    const formId = e.target && e.target.form && e.target.form.id;
    if (
      e.target &&
      e.target.name === 'id' &&
      e.target.form &&
      String(formId || '').indexOf('product-form-') === 0 &&
      e.target.value
    ) {
      this.updateIngredients(e.target.value);
    }
  }

  init() {
    const input = document.querySelector(
      'form[id^="product-form-"] input[name="id"]'
    );
    if (input && input.value) {
      this.updateIngredients(input.value);
    }

    document.removeEventListener('variant-change', this.boundOnVariantChange);
    document.addEventListener('variant-change', this.boundOnVariantChange);

    document.body.removeEventListener('change', this.boundOnVariantIdChange);
    document.body.addEventListener('change', this.boundOnVariantIdChange);
  }

  destroy() {
    document.removeEventListener('variant-change', this.boundOnVariantChange);
    document.body.removeEventListener('change', this.boundOnVariantIdChange);
  }
}

function initVariantIngredients() {
  const sections = document.querySelectorAll(
    '[data-section-type="variant-ingredients"]'
  );

  sections.forEach(function (sectionEl) {
    const instance = new VariantIngredients(sectionEl);
    instance.init();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantIngredients);
} else {
  initVariantIngredients();
}
